import React from 'react';
import { Group, useBreakpoint } from '@landr/maestro';
import { CarouselHeader } from '../GenericCarousel.styled';
import { Title, SeeMore } from './';

export const Header = () => {
    const isMd = useBreakpoint('md');

    return (
        <CarouselHeader
            alignItems={isMd ? 'flex-start' : 'space-between'}
            direction={isMd ? 'vertical' : 'horizontal'}
            gutter={isMd ? 'xs' : 'xl'}
        >
            <Group.Item>
                <Title />
            </Group.Item>
            <Group.Item>
                <SeeMore />
            </Group.Item>
        </CarouselHeader>
    );
};
